import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { AppInsightService } from './app-insight.service';
import { AppService } from './app.service';
import { AuthService } from './auth.service';
import { ErrorDiagnosticService } from './error-diagnostic.service';

@Injectable({
  providedIn: 'root'
})
export class AuthGuardGuard implements CanActivate {
  constructor(public auth: AuthService, private appService: AppService, public router: Router, private appInsightService : AppInsightService, private diagnosticService : ErrorDiagnosticService ) { }
  
  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
      
    this.diagnosticService.setMethodName("auth-guard.guard.canActivate()")
    if (!this.auth.isAuthenticated()) {
      if (!this.appService.inPortal()) {
        this.appInsightService.logTrace("limpieza de localStorage", this.diagnosticService.getDetails());
        localStorage.clear();
        this.appInsightService.logTrace("loginRedirectAd desde auth-guard.guard", this.diagnosticService.getDetails());
        this.auth.loginRedirectAd();
      }
      else {
        //this.auth.logoutProv('TEAM');
        this.auth.logout();
      }
      return false;
    }
    return true;
  }

}
